export interface City {
  slug: string;
  name: string;
  nameLocative: string;
  priority: "P0" | "P1" | "P2";
}

type Coordinates = {
  lat: number;
  lng: number;
};

export const CITIES: City[] = [
  {
    slug: "krakow",
    name: "Kraków",
    nameLocative: "w Krakowie",
    priority: "P0",
  },
  {
    slug: "warszawa",
    name: "Warszawa",
    nameLocative: "w Warszawie",
    priority: "P0",
  },
  {
    slug: "wroclaw",
    name: "Wrocław",
    nameLocative: "we Wrocławiu",
    priority: "P0",
  },
  {
    slug: "poznan",
    name: "Poznań",
    nameLocative: "w Poznaniu",
    priority: "P0",
  },
  {
    slug: "lodz",
    name: "Łódź",
    nameLocative: "w Łodzi",
    priority: "P0",
  },
  {
    slug: "gdansk",
    name: "Gdańsk",
    nameLocative: "w Gdańsku",
    priority: "P0",
  },
  {
    slug: "katowice",
    name: "Katowice",
    nameLocative: "w Katowicach",
    priority: "P0",
  },
  {
    slug: "szczecin",
    name: "Szczecin",
    nameLocative: "w Szczecinie",
    priority: "P0",
  },
  {
    slug: "lublin",
    name: "Lublin",
    nameLocative: "w Lublinie",
    priority: "P1",
  },
  {
    slug: "bydgoszcz",
    name: "Bydgoszcz",
    nameLocative: "w Bydgoszczy",
    priority: "P1",
  },
  {
    slug: "bialystok",
    name: "Białystok",
    nameLocative: "w Białymstoku",
    priority: "P1",
  },
  {
    slug: "gdynia",
    name: "Gdynia",
    nameLocative: "w Gdyni",
    priority: "P1",
  },
  {
    slug: "czestochowa",
    name: "Częstochowa",
    nameLocative: "w Częstochowie",
    priority: "P1",
  },
  {
    slug: "radom",
    name: "Radom",
    nameLocative: "w Radomiu",
    priority: "P1",
  },
  {
    slug: "torun",
    name: "Toruń",
    nameLocative: "w Toruniu",
    priority: "P1",
  },
  {
    slug: "rzeszow",
    name: "Rzeszów",
    nameLocative: "w Rzeszowie",
    priority: "P1",
  },
  {
    slug: "kielce",
    name: "Kielce",
    nameLocative: "w Kielcach",
    priority: "P1",
  },
  {
    slug: "gliwice",
    name: "Gliwice",
    nameLocative: "w Gliwicach",
    priority: "P1",
  },
  {
    slug: "zabrze",
    name: "Zabrze",
    nameLocative: "w Zabrzu",
    priority: "P1",
  },
  {
    slug: "olsztyn",
    name: "Olsztyn",
    nameLocative: "w Olsztynie",
    priority: "P1",
  },
  {
    slug: "bielsko-biala",
    name: "Bielsko-Biała",
    nameLocative: "w Bielsku-Białej",
    priority: "P2",
  },
  {
    slug: "rybnik",
    name: "Rybnik",
    nameLocative: "w Rybniku",
    priority: "P2",
  },
  {
    slug: "tychy",
    name: "Tychy",
    nameLocative: "w Tychach",
    priority: "P2",
  },
  {
    slug: "dabrowa-gornicza",
    name: "Dąbrowa Górnicza",
    nameLocative: "w Dąbrowie Górniczej",
    priority: "P2",
  },
  {
    slug: "plock",
    name: "Płock",
    nameLocative: "w Płocku",
    priority: "P2",
  },
  {
    slug: "opole",
    name: "Opole",
    nameLocative: "w Opolu",
    priority: "P2",
  },
  {
    slug: "elblag",
    name: "Elbląg",
    nameLocative: "w Elblągu",
    priority: "P2",
  },
  {
    slug: "walbrzych",
    name: "Wałbrzych",
    nameLocative: "w Wałbrzychu",
    priority: "P2",
  },
  {
    slug: "zielona-gora",
    name: "Zielona Góra",
    nameLocative: "w Zielonej Górze",
    priority: "P2",
  },
  {
    slug: "koszalin",
    name: "Koszalin",
    nameLocative: "w Koszalinie",
    priority: "P2",
  },
];

export const CITY_COORDINATES: Record<string, Coordinates> = {
  krakow: { lat: 50.0647, lng: 19.945 },
  warszawa: { lat: 52.2297, lng: 21.0122 },
  wroclaw: { lat: 51.1079, lng: 17.0385 },
  poznan: { lat: 52.4064, lng: 16.9252 },
  lodz: { lat: 51.7592, lng: 19.456 },
  gdansk: { lat: 54.352, lng: 18.6466 },
  katowice: { lat: 50.2649, lng: 19.0238 },
  szczecin: { lat: 53.4285, lng: 14.5528 },
  lublin: { lat: 51.2465, lng: 22.5684 },
  bydgoszcz: { lat: 53.1235, lng: 18.0084 },
  bialystok: { lat: 53.1325, lng: 23.1688 },
  gdynia: { lat: 54.5189, lng: 18.5305 },
  czestochowa: { lat: 50.8118, lng: 19.1203 },
  radom: { lat: 51.4027, lng: 21.1471 },
  torun: { lat: 53.0138, lng: 18.5984 },
  rzeszow: { lat: 50.0412, lng: 21.9991 },
  kielce: { lat: 50.8661, lng: 20.6286 },
  gliwice: { lat: 50.2945, lng: 18.6714 },
  zabrze: { lat: 50.3249, lng: 18.7857 },
  olsztyn: { lat: 53.7784, lng: 20.4801 },
  "bielsko-biala": { lat: 49.8224, lng: 19.0444 },
  rybnik: { lat: 50.1022, lng: 18.5463 },
  tychy: { lat: 50.1372, lng: 18.9664 },
  "dabrowa-gornicza": { lat: 50.3186, lng: 19.2374 },
  plock: { lat: 52.5463, lng: 19.7065 },
  opole: { lat: 50.6751, lng: 17.9213 },
  elblag: { lat: 54.1522, lng: 19.4045 },
  walbrzych: { lat: 50.784, lng: 16.2844 },
  "zielona-gora": { lat: 51.9356, lng: 15.5062 },
  koszalin: { lat: 54.1944, lng: 16.1722 },
};

const normalizeCityTerm = (value: string): string =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

const toRadians = (value: number): number => (value * Math.PI) / 180;

const getDistanceInKilometers = (
  from: Coordinates,
  to: Coordinates
): number => {
  const earthRadiusKm = 6371;
  const latDelta = toRadians(to.lat - from.lat);
  const lngDelta = toRadians(to.lng - from.lng);
  const fromLat = toRadians(from.lat);
  const toLat = toRadians(to.lat);

  const a =
    Math.sin(latDelta / 2) ** 2 +
    Math.cos(fromLat) * Math.cos(toLat) * Math.sin(lngDelta / 2) ** 2;

  return 2 * earthRadiusKm * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export function getCityBySlug(slug: string): City | undefined {
  return CITIES.find((c) => c.slug === slug);
}

export function findCityByName(value: string): City | null {
  const normalizedValue = normalizeCityTerm(value);
  if (!normalizedValue) return null;

  return (
    CITIES.find(
      (city) =>
        normalizeCityTerm(city.name) === normalizedValue ||
        normalizeCityTerm(city.slug) === normalizedValue
    ) ?? null
  );
}

export function findNearestCity(latitude: number, longitude: number): City | null {
  const currentLocation = { lat: latitude, lng: longitude };
  let nearestCity: City | null = null;
  let nearestDistance = Number.POSITIVE_INFINITY;

  for (const city of CITIES) {
    const cityCoordinates = CITY_COORDINATES[city.slug];
    if (!cityCoordinates) continue;

    const distance = getDistanceInKilometers(currentLocation, cityCoordinates);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestCity = city;
    }
  }

  return nearestCity;
}
